import React, { FC } from 'react';
import TurboLiveProvider from '@/turbo-live/context/TurboLiveProvider';
import MarketCategories from 'nike-ui/src/components/turboLive/components/detail/MarketCategories';
import { MatchMediaProvider } from 'nike-ui/src/components/turboLive/hooks/useMatchMedia';

const MarketCategoriesWrapper: FC<{ matchId: string; otherClass?: string }> = ({ matchId, otherClass }) => (
    <TurboLiveProvider>
        <MatchMediaProvider>
            <MarketCategories matchId={matchId} sectionType="PREMATCH" />
        </MatchMediaProvider>
    </TurboLiveProvider>
);

export default MarketCategoriesWrapper;
